<bizz-flow-status (backClick)="removeFromViewStack()" [flowStatus]="flowStatus!"></bizz-flow-status>